import script from "./MediaInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./MediaInput.vue?vue&type=script&lang=ts&setup=true"

import "./MediaInput.vue?vue&type=style&index=0&id=b9437110&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9437110"]])

export default __exports__